import * as actionTypes from "../../Actions";

const initialState = {
    translationTypes: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TRANSLATION_TYPES:
            return {
                ...state,
                translationTypes: action.payload
            }
        default:
            return state;
    }
}

export default reducer;
